<template>
  <b-card no-body style="border: none; height: 100%; margin: 0;">
    <b-table no-provider-paging responsive id="my-table" :items="tableData"
             :per-page="perPage"
             :current-page="currentPage"
             tbody-tr-class="test"
             :fields="fields" v-on:row-clicked="rowClicked"
             :sort-by="sortBy"
             :sort-desc="sortDesc"
             sort-icon-left
             class="custom-auto-height">
      <template #table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: calcSize(field.key) }"
        />
      </template>
      <template #row-details="data">
        <div @click="rowClicked(data.item, data.index, $event)" style="padding: 0.15rem 0.75rem !important; margin-left: 0px; margin-top: -10px">
          <span class="message-memo" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: block; max-width: 40vw;">{{data.item.description}}</span>
        </div>
      </template>
    </b-table>
    <div class="mt-3 custom-flex-0">
      <b-pagination v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"

                    aria-controls="my-table" align="center"></b-pagination>
    </div>
  </b-card>
</template>

<script>
import {Server_URL, Server_URL_MAENGELMELDER} from "../../shared/utils";
import {decryptAES, decryptFile} from "../../shared/crypto";




export default {
  name: 'TaskSeriesTable',
  components: {},
  props:{
    tableData: {
      type: Array,
      default: () => []
    },
    rowClickCallback: {
      type: Function,
      default: undefined
    },
  },
  mounted() {

  },
  data: () => {
    return {
      sortBy: 'create_date',
      sortDesc: true,
      fields: [
        {key: 'auftrag_wo', label: "Betreff", sortable: true},
        {key: 'auftrag_was', label: "Auftrag Was", sortable: true},
        {key: 'series_type', label: "Wiederholung", sortable: false, formatter: 'intervalToString'},
        {key: 'start_date', label: "Serienstart", formatter: "dateToString", sortable: true},
        {key: 'end_date', label: "Serienende", formatter: "dateToString", sortable: true},
        {key: 'create_date', label: "Anlage", formatter: "dateToString", sortable: true},
      ],
      currentPage: 1,
      perPage: 20,
      url: Server_URL,
      urlMm: Server_URL_MAENGELMELDER,
      currentClicked: null,
      indeterminate: false,
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.$emit('page-changed', newValue);

    },
  },
  computed: {
    rows() {
      return this.tableData.length
    },
  },
  methods: {
    calcSize(field) {
      if (field === 'selected') {
        return '36px';
      } else {
        return 'initial';
      }
    },
    rowClicked(item, index, target) {
      this.$router.push("/auftraege/task_series/"+item.id);
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    intervalToString(value) {
      if (value === null) {
        return ""
      }
      switch (value) {
        case "D":
          return "Täglich";
        case "W":
          return "Wöchentlich";
        case "M":
          return "Monatlich";
        case "Y":
          return "Jährlich";
      }
    },
    formateMemo(value) {
      if (value === null) {
        return "";
      }
      if (value.length > 80)
        return value.substring(0,80) + '...';
      else
        return value;
    },
    responseError(response) {
      console.log(response)
    },

    changePage(page) {
      if (page !== this.currentPage && ((page - 1) * this.perPage) < this.rows) {
        this.currentPage = page;
      }
    }
  }
}
</script>

<style scoped>


.h-1px {
  height: 1px;
}

.icon-def-grey {
  color: #5f6368;
}

.icon-def-green {
  color: green;
}

::v-deep .table td {
  padding: 0.15rem 0.75rem !important;
}

::v-deep table.b-table > tbody > tr.b-table-details > td {
  border-top: none !important;
  padding: 0px !important;
}

::v-deep .table.b-table>thead>tr>th[aria-sort]:before {
  float: none !important;
  margin-left: 0 !important;
  margin-right: 0.5em !important;
  font-size: larger;
}

::v-deep .table.b-table>thead>tr>th[aria-sort="ascending"] {
  border: 2px solid #c8ced3;;
}

::v-deep .table.b-table>thead>tr>th[aria-sort="descending"] {
  border: 2px solid #c8ced3;;
}

::v-deep .table thead th {
  white-space: nowrap;
}

.message-subject {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  line-height: 30px;
  font-weight: normal;
  color: #202124;
  vertical-align: sub;
}

.message-body {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #383838;
  font-weight: normal;
  vertical-align: sub;
}

.message-memo {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #5f6368;
  font-weight: normal;
  vertical-align: sub;
}
</style>

